"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(require("lodash/get"));
var uuid_1 = __importDefault(require("uuid"));
var WebchatApi = /** @class */ (function () {
    function WebchatApi(axiosInstance) {
        var _this = this;
        this.handleApiError = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = (0, get_1.default)(error, 'response.data', {});
                        if (!(data && typeof data === 'string' && data.includes('BP_CONV_NOT_FOUND'))) return [3 /*break*/, 2];
                        console.error('Conversation not found, starting a new one...');
                        return [4 /*yield*/, this.createConversation()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (data.errorCode === 'BP_0401') {
                            this.updateAxiosConfig({ botId: this.botId, externalAuthToken: undefined });
                            console.error('External token expired or invalid. Removed from future requests');
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.axios = axiosInstance;
        this.axios.interceptors.request.use(function (config) {
            if (!config.url.includes('/botInfo')) {
                var prefix = config.url.indexOf('?') > 0 ? '&' : '?';
                config.url = "".concat(config.url).concat(prefix, "__ts=").concat(new Date().getTime());
            }
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
        this.updateAxiosConfig();
    }
    Object.defineProperty(WebchatApi.prototype, "baseUserPayload", {
        get: function () {
            return {
                webSessionId: window.__BP_VISITOR_SOCKET_ID
            };
        },
        enumerable: false,
        configurable: true
    });
    WebchatApi.prototype.updateAxiosConfig = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.botId, botId = _c === void 0 ? undefined : _c, _d = _b.externalAuthToken, externalAuthToken = _d === void 0 ? undefined : _d;
        this.botId = botId;
        this.axiosConfig = botId
            ? { baseURL: "".concat(window.location.origin).concat(window.BOT_API_PATH, "/mod/channel-web") }
            : { baseURL: "".concat(window.BOT_API_PATH, "/mod/channel-web") };
        if (externalAuthToken) {
            this.axiosConfig = __assign(__assign({}, this.axiosConfig), { headers: {
                    ExternalAuth: "Bearer ".concat(externalAuthToken),
                    'X-BP-ExternalAuth': "Bearer ".concat(externalAuthToken)
                } });
        }
    };
    WebchatApi.prototype.setCustomUserId = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/users/customId', __assign(__assign({}, this.baseUserPayload), { customId: userId }), this.axiosConfig)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error('Error while setting a custom user id', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.fetchBotInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.get('/botInfo', this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        err_2 = _a.sent();
                        console.error('Error while loading bot info', err_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.fetchPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/preferences/get', this.baseUserPayload, this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        err_3 = _a.sent();
                        console.error('Error while fetching preferences', err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.updateUserPreferredLanguage = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/preferences', __assign(__assign({}, this.baseUserPayload), { language: language }), this.axiosConfig)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        console.error('Error in updating user preferred language', err_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.fetchConversations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/conversations/list', this.baseUserPayload, this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        err_5 = _a.sent();
                        console.error('Error while fetching convos', err_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.fetchConversation = function (conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.axios.post('/conversations/get', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId }), this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        err_6 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_6)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.resetSession = function (conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/conversations/reset', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId }), this.axiosConfig)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_7 = _a.sent();
                        console.error('Error while resetting conversation', err_7);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.createConversation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/conversations/new', this.baseUserPayload, this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.convoId];
                    case 2:
                        err_8 = _a.sent();
                        console.error('Error in create conversation', err_8);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.downloadConversation = function (conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.post('/conversations/download/txt', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId }), this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, { name: data.name, txt: data.txt }];
                    case 2:
                        err_9 = _a.sent();
                        console.error('Error in download conversation', err_9);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.sendEvent = function (payload, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        return [2 /*return*/, this.axios.post('/events', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId, payload: payload }), this.axiosConfig)];
                    case 1:
                        err_10 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_10)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.sendMessage = function (payload, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        return [2 /*return*/, this.axios.post('/messages', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId, payload: payload }), this.axiosConfig)];
                    case 1:
                        err_11 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_11)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.deleteMessages = function (conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.axios.post('/conversations/messages/delete', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId }), this.axiosConfig)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_12 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_12)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.sendFeedback = function (feedback, messageId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        return [2 /*return*/, this.axios.post('/saveFeedback', { messageId: messageId, target: window.__BP_VISITOR_ID, feedback: feedback }, this.axiosConfig)];
                    case 1:
                        err_13 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_13)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.getMessageIdsFeedbackInfo = function (messageIds) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.axios.post('/feedbackInfo', { messageIds: messageIds, target: window.__BP_VISITOR_ID }, this.axiosConfig)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        err_14 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_14)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.uploadFile = function (file, payload, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        data = new FormData();
                        data.append('file', file);
                        data.append('webSessionId', this.baseUserPayload.webSessionId);
                        data.append('conversationId', conversationId);
                        data.append('payload', payload);
                        return [2 /*return*/, this.axios.post('/messages/files', data, this.axiosConfig)];
                    case 1:
                        err_15 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_15)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.sendVoiceMessage = function (voice, ext, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var audio, err_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        audio = {
                            buffer: voice.toString('base64'),
                            title: "".concat(uuid_1.default.v4(), ".").concat(ext)
                        };
                        return [2 /*return*/, this.axios.post('/messages/voice', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId, audio: audio }), this.axiosConfig)];
                    case 1:
                        err_16 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_16)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.setReference = function (reference, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        return [2 /*return*/, this.axios.post('/conversations/reference', __assign(__assign({}, this.baseUserPayload), { conversationId: conversationId, reference: reference }), this.axiosConfig)];
                    case 1:
                        err_17 = _a.sent();
                        return [4 /*yield*/, this.handleApiError(err_17)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WebchatApi.prototype.listByIncomingEvent = function (messageId) {
        return __awaiter(this, void 0, void 0, function () {
            var messages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/messaging/list-by-incoming-event/".concat(messageId), {
                            baseURL: window['BOT_API_PATH']
                        })];
                    case 1:
                        messages = (_a.sent()).data;
                        return [2 /*return*/, messages];
                }
            });
        });
    };
    return WebchatApi;
}());
exports.default = WebchatApi;
